import React, { Component } from 'react';
import QRCode from 'qrcode.react';
import { Button } from 'reactstrap';
import AuthService from '../../utils/auth.service';
import Loading from '../../components/Loading';
import MessageModal from '../../components/Message'; 

class ProfileSecurityPage extends Component {

  constructor(props) {
    super(props);
    this.state = {
      profile: AuthService.currentUser,
      transfer: {},
      loading: false,
      modal: {
        title: '',
        message: '', 
        isOpen: true
      }
    };

    document.addEventListener('profileLoaded', (data) => {
      if(data.detail) {
        this.setState(...this.state, {
          profile: data.detail.profile,
        });
      }
    });

    this.handleSubmitProfile = this.handleSubmitProfile.bind(this);
    this.handleInput = this.handleInput.bind(this);
    this.toggleAlert = this.toggleAlert.bind(this);
    this.handleBack = this.handleBack.bind(this);
  }

  handleBack() {
    this.props.history.goBack();
  }

  toggleAlert() {
    this.setState(...this.state, { modal: { isOpen: !this.state.modal.isOpen }})
  }

  handleInput(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    let profile = this.state.profile;
    profile[name] = value; 

    this.setState(...this.state, { profile: profile }); 

    if(this.state.profile.code.replace(' ', '').length === 6) {
      this.handleSubmitProfile();
    }
  }

  handleSubmitProfile() {
    this.setState(...this.state, { loading: true });

    AuthService.update(this.state.profile, 'tfa')
      .then(data => {
        this.setMessage('All changes were saved', data.message);
        AuthService.refresh();
      }).catch(() => {
        this.setMessage('TFA Confirmation Error', 'Check if you type the correct TFA code and try again!');
      }); 

  }

  setMessage(title, message) {
    this.setState(...this.state, { modal: {
      title: title,
      message: message, 
      isOpen: true
    },
    loading: false
  });
  }

  render() {
    return (
      <section className="profile-page">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-8 float-left">
              <h4 className="pt-4">
                2 Factor Auth (TFA)
              </h4>
              <button onClick={ this.handleBack } className="btn btn-outline-secondary float-right">
                Back
              </button> {/* Back */}
              <hr />
            </div>
          </div> {/* Tfa */}

          <div className="row justify-content-center" hidden={!this.state.profile.tfa_active}>
            <div className="col-md-3">
              <h5>Cancel TFA Service</h5>
              <hr />
              <div className="form-group">
                <label htmlFor="code">Confirm your Code</label>
                <input type="text"
                    className="form-control"
                    name="code"
                    onChange={this.handleInput}
                    value={this.state.profile.code}
                    maxLength="7" />

                <Button
                  className="float-right"
                  color="secondary mt-2"
                  onClick={ this.handleSubmit }
                  type="submit">
                Cancel TFA
                </Button>
              </div>
            </div>
            <div className="col-md-5">
              <h5>Cancel Information</h5>
              <hr />
              <ul>
                <li>Use your current Google Authentication Code</li>
                <li>Confirm the code in the field "confirm your code"</li>
                <li>Done, your TFA will be cancelled</li>
              </ul>
            </div>
          </div> {/* Cancel Tfa */}
          <div className="row justify-content-center" hidden={this.state.profile.tfa_active}>

            <div className="col-md-2">
              <h5>QR Code</h5>
              <hr />
              <div className="bg-secondary d-block p-3">
                <QRCode value={ this.state.profile.tfa && this.state.profile.tfa.ga ? this.state.profile.tfa.ga : '' } />
              </div>
            </div>

            <div className="col-md-3">
              <h5>Check Code</h5>
              <hr />
              <div className="form-group">
                <label htmlFor="code">Confirm your Code</label>
                <input type="text"
                    className="form-control"
                    name="code"
                    onChange={this.handleInput}
                    value={this.state.profile.code}
                    maxLength="7" />

                <Button
                  className="float-right"
                  color="secondary mt-2"
                  onClick={ this.handleSubmit }
                  type="submit">
                Check
                </Button>
              </div>
            </div>

            <div className="col-md-3">
              <h5>Usage Information</h5>
              <hr />
              <ul>
                <li>Download the <a target="_blank" href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=en">Google Authentication</a> in your App Store</li>
                <li>Read the QR with de GA app</li>
                <li>Confirm the code in the field beside</li>
              </ul>

            </div>

          </div> {/* Check */}
        </div>
        <Loading active={this.state.loading} />
        <MessageModal isOpen={ this.state.modal.title }
                        toggle={ this.toggleAlert }
                        title={ this.state.modal.title }
                        message={ this.state.modal.message } />
      </section>);
  }

}

export default ProfileSecurityPage;


// WEBPACK FOOTER //
// ./src/containers/ProfileSecurityPage/index.js